import * as React from 'react';

// @ts-expect-error
import type {FieldProps} from 'redux-form';

import type {SessionUser as SessionUserFragment} from 'nutshell-graphql-types';

import {EmailFromSelection} from '../../header/email-from-selection';

type FromFieldProps = FieldProps & {
    user: SessionUserFragment;
};
export const FromField: (...args: any) => any = ({user, input}: FromFieldProps) => {
    return <EmailFromSelection {...input} selectedAddress={input.value} user={user} />;
};
